import { gql } from '@apollo/client';

export const GET_QUALITATIVE_FACTOR_WORKAROUND_STATS = gql`
  query GetQualitativeFactorWorkaroundStats($locationUUID: String) {
    getQualitativeFactorWorkaroundStats(locationUUID: $locationUUID) {
      qualitativeFactorId
      name
      totalTaggedApplications
      applicationsWithWorkarounds
      completionPercentage
      isDefault
    }
  }
`;

export const SET_QUALITATIVE_FACTOR_WORKAROUND = gql`
  mutation SetQualitativeFactorWorkaround(
    $data: SetQualitativeFactorWorkaroundInput!
  ) {
    setQualitativeFactorWorkaround(data: $data)
  }
`;

export const GET_QUALITATIVE_FACTOR_WORKAROUNDS = gql`
  query GetQualitativeFactorWorkarounds(
    $data: GetQualitativeFactorWorkaroundsInput!
  ) {
    getQualitativeFactorWorkarounds(data: $data) {
      qualitativeFactorId
      qualitativeFactorName
      itApplicationId
      itApplicationName
      locationId
      sla
      rto
      mto
      rpo
      isWorkaroundNeeded
      workaroundDefined
      runtimeHours
      maxDataLossHours
      workaroundDescription
      workaroundTimelineCompliance {
        slaCompliant
        rtoCompliant
        mtoCompliant
        rpoCompliant
      }
      createdAt
      updatedAt
      workaroundUpdatedAt
    }
  }
`;
